import React from 'react';
import './burger-menu.scss';

import classNames from 'classnames';
import SearchForm from '../search-form';
import Menu, { MenuItemsType } from '../../menu';
import PopupButton from '../../popup-button';

const BurgerMenu = ({ items }) => (
  <PopupButton
    className="burger-menu popup-button--burger-menu"
    buttonBody={(
      <div
        className="burger-menu__button-icon bvi-eye bvi-color"
      >
        <span className="burger-menu__icon-dash" />
        <span className="burger-menu__icon-dash" />
        <span className="burger-menu__icon-dash" />
      </div>
    )}
    popupBody={(
      <>
        <SearchForm className="burger-menu__search-form" placeholder="Поиск" />
        <Menu items={items} />
      </>
    )}
  />
);

BurgerMenu.propTypes = {
  items: MenuItemsType,
};

BurgerMenu.defaultProps = {
  items: [],
};

export default BurgerMenu;
